<template>
  <div style="height: 100%">
    <!-- <div v-if="this.loading" class="loader">Loading...</div> -->

    <div >
      
      <div>
        <EditAssetForm
          v-if="this.toggleEditAssetForm == true"
          :machine="this.currenteditedasset"
          v-on:update-asset-locally="updateAssetLocally($event)"
          v-on:close-EditAssetForm="toggleEditAssetFormmethod()"
        />
        <DeleteAssetForm
          v-if="this.toggleDeleteAssetForm == true"
          :machine="this.currentdeletingasset"
          v-on:machine-deleted="deleteAssetLocally($event)"
          v-on:close-DeleteAssetForm="toggledeleteassetformmethod()"
        />
      </div>


    <div 
      v-if="
          this.toggleEditAssetForm == false &&
          this.toggleDeleteAssetForm == false 
      ">
      <el-card style="width: 85%; margin:2% auto; padding:">
        <el-input
          v-model="search"
          size="mini"
          style="width: 30%; padding: 20px; float: right;"
          placeholder="Type to search in machine name"
        />

        <el-table
          :data="this.machinesofproperty.filter(data => !search || data.machinename.toLowerCase().includes(search.toLowerCase()))"
          height="60vh"
          style="width: 100%; cursor: pointer;"
          ref="assetTable"
          @current-change="directToMachinePage"
          @sort-change="saveSortOrder"

        >


          <el-table-column width="100" align="center">
            <template slot-scope="scope">
              <el-image style="width: 50px; height: 50px" :src="scope.row.imageurl[0]" ></el-image>
            </template>
          </el-table-column>

          <el-table-column label="Machine name" prop="machinename" sortable :sort-method="sortMachineNames">

          </el-table-column>


          <el-table-column prop="description" label="Description" sortable>

          </el-table-column>
        
          <el-table-column
            v-if="this.$route.path.includes('UsersAssets')"
            prop="propertyname"
            label="Property name"
            sortable
          ></el-table-column>

          <el-table-column
            v-if="this.$route.path.includes('UsersAssets')"
            prop="ownername"
            label="Owner name"
            sortable
          ></el-table-column>

           <el-table-column prop="installdate" label="Install date">
                <template slot-scope="scope">
                  {{ scope.row.installdate | moment(
                    'timezone',
                     $timeZone,
                    'MMM DD YYYY hh:mm A') }}
                </template>
              </el-table-column>

        <el-table-column width="250px;" style="">
         <template slot-scope="scope">

             <el-badge style="bottom: -9px; height: 50px; margin-right: 15px;" :value="scope.row.unreadlogcount">
                <router-link :to="{ path: `/MachinebyId/${scope.row.machineid}#tab1` }">
                  <el-button type="primary"> 
                    Notes
                  </el-button>
                </router-link>
            </el-badge>

            <el-badge style="bottom: -9px; height: 50px; " :value="scope.row.unreadcommentcount">
                <router-link :to="{ path: `/MachinebyId/${scope.row.machineid}#tab2` }">
                  <el-button type="primary"> 
                    Work Orders
                  </el-button>
                </router-link>
            </el-badge>


         </template>
        </el-table-column>
        <el-table-column v-if="this.machinesofproperty[0].customfields.length > 0" label="Custom fields">
        <div v-if="this.machinesofproperty.length > 0">

          <div v-for="(customField, index) in this.machinesofproperty[0].customfields" :key="customField.customfieldid">
                  <el-table-column :prop="getPropForCustomField(index)" :label="customField.customfieldtitle">

                  </el-table-column>
          </div>
        </div>
        </el-table-column>
          <el-table-column  width="60:px;">
            
              <template slot-scope="scope">


                               <div>
                                  <el-dropdown
                                    v-if="scope.row.permissions.candelete == true || scope.row.permissions.canedit == true "
                                    trigger="click"
                                    style="margin-top:-10px;"
                                  >
                                    <el-button v-on:click.stop type="text">
                                      <i class="el-icon-s-operation"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">

                                      <el-dropdown-item>
                                        <el-button
                                          v-if="scope.row.permissions.canedit == true"
                                          @click.native="
                                            toggleEditAssetFormmethod(scope.row)
                                          "
                                          type="text"
                                          style="margin-left:5px; margin-right:5px; color:unset;"
                                        >
                                          <i class="fa fa-edit mt-2" /> Edit
                                          Asset
                                        </el-button>
                                      </el-dropdown-item>

                                      <el-dropdown-item>
                                        <el-button
                                          v-if="scope.row.permissions.candelete == true"
                                          type="text"
                                          @click.native="
                                            toggledeleteassetformmethod(scope.row)
                                          "
                                          style="margin-left:5px; margin-right:5px; color:unset;"
                                        >
                                          <i class="fa fa-trash mt-2" /> Delete
                                          Asset
                                        </el-button>
                                      </el-dropdown-item>

                                    </el-dropdown-menu>
                                  </el-dropdown>
                                </div>
            
                  </template>



           </el-table-column>

        </el-table>
      </el-card>
    </div>
    </div>
  </div>
</template>
<script>
import EventService from "@/services/EventService.js";
import Router from "vue-router";
import { mapActions, mapState } from "vuex";
import EditAssetForm from "@/components/assets/EditAssetForm.vue";
import DeleteAssetForm from "@/components/assets/DeleteAssetForm.vue";
import LogRocket from 'logrocket';

export default {
  components: {
    EditAssetForm,
    DeleteAssetForm
  },
  props:{
    machinesofproperty: Array
  },

  data() {
    return {
      search: "",
      currentRow: null,
      loading: true,
      toggleEditAssetForm: false,
      toggleDeleteAssetForm: false,
    };
  },
  mounted(){
    if(this.savedTableSorting != undefined && this.machinesofproperty.length > 0)
    {
      this.$refs.assetTable.sort(this.savedTableSorting.sortProp,
      this.savedTableSorting.sortOrder
      )
    }
   
  },
  methods: {
    ...mapActions(["addSortSettings"]),
    updateAssetLocally(updatedassetpackage) {
      this.$set(
        this.machinesofproperty,
        this.machinesofproperty.indexOf(updatedassetpackage[1]),
        updatedassetpackage[0]
      );
    },
    // this is a hack to be able to tell for the table on which row of the custom fields it is to retrieve the value for this row
    getPropForCustomField(index){
        return "customfields[" + index + "].customfieldvalue" 
    }, 
    toggleEditAssetFormmethod(machine) {
      this.toggleEditAssetForm = !this.toggleEditAssetForm;
      console.log(machine)
      this.currenteditedasset = machine;
      this.changeBackButton();
    },
      deleteAssetLocally($event) {
      console.log("delete asset locally is running" + $event);
      // console.log(
      //   "this is the index of the property " +
      //     this.propertyassets.indexOf($event)
      // );
      this.$delete(
        this.machinesofproperty,
        this.machinesofproperty.indexOf($event)
      );
    },
    toggledeleteassetformmethod(machine) {
      this.toggleDeleteAssetForm = !this.toggleDeleteAssetForm;
      this.currentdeletingasset = machine;
      this.changeBackButton();
    },
      changeBackButton() {
      this.$root.$emit("form-toggled");
    },
    sortMachineNames(a, b){
      
    if(a.machinename.toLowerCase() < b.machinename.toLowerCase()) { return -1; }
    if(a.machinename.toLowerCase() > b.machinename.toLowerCase()) { return 1; }
    return 0;

    },
    directToMachinePage(val) {
      this.currentRow = val;
      this.$router.push({ path: `/MachinebyId/${this.currentRow.machineid}` });
    },
    saveSortOrder(sortObject){
        var sortForAssetsInProperty = {
            "sortProp": sortObject.prop,
            "sortOrder": sortObject.order,
            "propertyId": this.$route.params.propertyid
            }

        this.addSortSettings(sortForAssetsInProperty);
    }

  },

  created() {


          this.machinesofproperty.forEach((machine, index) => {
            if(machine.unreadlogcount == 0){
              this.machinesofproperty[index].unreadlogcount = null;
            }

            if(machine.unreadcommentcount == 0){
              this.machinesofproperty[index].unreadcommentcount = null;
            }

        
     
    })
  },
  computed: {

    savedTableSorting: function(){

      return  this.$store.state.savedAsssetTableSorting.savedAsssetTableSorting.filter(obj => {
        return obj.propertyId == this.$route.params.propertyid
      })[0]
    }
  }
};
</script>
<style scoped>
.el-card__body {
  padding: 0px;
}

a {
  color: #02746E;
  text-decoration: underline;
}
</style>